import { CanvasRenderingTarget2D } from 'fancy-canvas'
import { positionsBox } from './drawing.helper'
import DrawingPaneRenderer, { DrawingPaneRendererOptions } from './drawing.paneRenderer'


export type DrawingPaneAxisRendererOptions = DrawingPaneRendererOptions & {
    horizontal: boolean
}

class DrawingPaneAxisRenderer extends DrawingPaneRenderer {
    horizontal: boolean

    constructor(options: DrawingPaneAxisRendererOptions) {
        super(options)
        this.horizontal = options.horizontal
    }

    draw(target: CanvasRenderingTarget2D) {
        target.useBitmapCoordinateSpace(scope => {
            const config = this.drawing.getPaneAxisViewConfig(this.id)
            const { p1, p2, fill, fillColor } = config
            if (!fill) return
            const ctx = scope.context
            ctx.globalAlpha = 0.3
            const scaleWidth = this.horizontal ? this.drawing.getTimeScaleWidth() : this.drawing.getPriceScaleWidth()
            const l1coord = this.horizontal ? this.drawing.timeToCoordinate(p1) : this.drawing.priceToCoordinate(p1)
            const l2coord = this.horizontal ? this.drawing.timeToCoordinate(p2) : this.drawing.priceToCoordinate(p2)
            if (!l1coord || !l2coord) return

            const positions = positionsBox(
                l1coord,
                l2coord,
                this.horizontal ? scope.horizontalPixelRatio : scope.verticalPixelRatio
            )
            ctx.fillStyle = fillColor
            ctx.fillRect(this.horizontal ? positions.position : 0, this.horizontal ? 0 : positions.position, this.horizontal ? positions.length : scaleWidth, this.horizontal ? scaleWidth : positions.length)
        })
    }
}


export default DrawingPaneAxisRenderer